import styled from 'styled-components';
import { Player } from '@lottiefiles/react-lottie-player';

interface ItemProps {
  readonly topLoader?: number;
}

export const LoginWrapper = styled.div`  
  position: relative;
  overflow: auto;
  height: 100%;
  width: 100vw;
`;

export const LoginBox = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  min-height: 100%;
  max-width: 568px;
  position: relative;
  align-items: center;
  box-sizing: border-box;
  flex-direction: column;
  padding: 48px 48px 30px;
  background-color: #fff;
  margin: 0 auto;
  @media(max-width: 1190px) {
    left: 100px;
    max-width: 568px;
  }
  @media(max-width: 1024px) {
    left: 0;
  }
  @media (max-width: 768px) {
    padding: 48px 15px 15px;
  }
  @media (max-width: 700px) {
    max-width: 100%;
  }
`;

export const Loader = styled(Player)<ItemProps>`
  width: 300px;
  height: 300px;
  z-index: 9999;
  position: absolute;
  transform: translateX(-50%);
  top: ${props => props.topLoader}px;
`

export const GoBackToLogin = styled.span`
  left: 54px;
  top: 69.9px;
  cursor: pointer;
  position: absolute;
  display: inline-block;
  @media(max-width: 768px) {
    left: 41px;
  }
  @media(max-width: 426px) {
    left: 30px;
  }
`;

export const LoginFooter = styled.span`
  margin: 0;
  right: 60px;
  bottom: 20px;
  font-size: 20px;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  position: absolute;
  letter-spacing: -0.02em;
  font-family: 'Proxima Nova';
  @media(max-width: 1190px) {
    right: 10px;
    font-size: 16px;
  }
  @media(max-width: 768px) {
    display: none;
  }
`;